import { EnvironmentId } from '../../environments/types';
import { RegistryId } from '../types/registry';

export const queryKeys = {
  base: () => ['registries'] as const,
  list: (environmentId?: EnvironmentId) =>
    [...queryKeys.base(), { environmentId }] as const,
  item: (registryId: RegistryId) => [...queryKeys.base(), registryId] as const,
  // mediaType is part of the key because it changes the result: callers that pass
  // one get only that artifact type, callers that omit it get every repository.
  // Without it both share one cache entry and whichever loads first wins.
  //
  // It is appended only when set, so the unfiltered key stays a prefix of every
  // filtered one — invalidating with just a registry id then reaches them all.
  repositoriesList: (registryId: RegistryId, mediaType?: string) => {
    const key = [...queryKeys.base(), registryId, 'repositoriesList'] as const;

    return mediaType ? ([...key, { mediaType }] as const) : key;
  },
};
